module.exports = __webpack_public_path__ + "static/media/loading-spinner.921c5857.gif";